import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { register } from 'swiper/element-bundle'
import { Swiper, SwiperSlide } from 'swiper/react' 
import { Navigation } from 'swiper/modules' // EffectCoverflow
import ReactPlayer from 'react-player'

import Error from '../Error/Error'

import 'swiper/css'
//import 'swiper/css/effect-coverflow';

import './MySwiperNavigation.css'
import './MySwiper.css'
import { Link } from 'react-router-dom'
import { getMediaUrl, urls } from '../../utils/routing'

register();

/*{
    video_id: 0,
    title: 'Озвучка экипажа «гусар» для мир танков',
    video_url: 'https://www.youtube.com/watch?v=1KASYghd_8A', // https://www.youtube.com/embed/1KASYghd_8A/?autoplay=1&hl=ru&rel=0
    link: '/pages/media/ozvuchka-ekipazha-gusar-dlya-mir-tankov/',
    publishedAt: "" // Формат ISO 8601 (например, '2023-10-27T10:00:00Z')
},*/

export default class MySwiper extends Component {
    static propTypes = {
        videos: PropTypes.arrayOf(PropTypes.shape({
            videoId: PropTypes.string,
            title: PropTypes.string,
            videoUrl: PropTypes.string,
            link: PropTypes.string,
            publishedAt: PropTypes.string,
        })).isRequired,
        
        isError: PropTypes.bool.isRequired,
        isErrorNotFound: PropTypes.bool.isRequired,
        isFetched: PropTypes.bool.isRequired,
        isFetching: PropTypes.bool.isRequired,

        fetchMedia: PropTypes.func.isRequired,
    }

    componentDidMount() {
        this.props.fetchMedia();

        /*if (this.props.videos.length === 0) {
            const element = document.getElementById('main_media_swiper');
            element.style.cssText = 'height: 250px;';
        }*/
    }

    renderSwiperHeader() {
        return (
            <div className='section-header'>
                <h2 className='section-header-text'>Медиа</h2>
                <Link
                    key={ urls.media }
                    to={ urls.media }
                    state={{ lastUrl: document.location.href }}
                    className='section-link'
                    //target={ target } slug: link.slug, 
                    preventScrollReset={true}
                >
                    Все медиа 
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="17" viewBox="0 0 8 17" fill="none" >
                        <path d="M1.63466 4.88666L2.34199 4.17999L6.19466 8.03133C6.25676 8.09304 6.30605 8.16642 6.33968 8.24726C6.37331 8.32809 6.39062 8.41478 6.39062 8.50233C6.39062 8.58988 6.37331 8.67656 6.33968 8.7574C6.30605 8.83823 6.25676 8.91161 6.19466 8.97333L2.34199 12.8267L1.63532 12.12L5.25132 8.50333L1.63466 4.88666Z" fill="#F9F5E1"></path>
                    </svg>
                </Link>
                {/* <a className='section-link' href="/pages/media/"> Все медиа 
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="17" viewBox="0 0 8 17" fill="none" >
                        <path d="M1.63466 4.88666L2.34199 4.17999L6.19466 8.03133C6.25676 8.09304 6.30605 8.16642 6.33968 8.24726C6.37331 8.32809 6.39062 8.41478 6.39062 8.50233C6.39062 8.58988 6.37331 8.67656 6.33968 8.7574C6.30605 8.83823 6.25676 8.91161 6.19466 8.97333L2.34199 12.8267L1.63532 12.12L5.25132 8.50333L1.63466 4.88666Z" fill="#F9F5E1"></path>
                    </svg>
                </a> */}
            </div>
        )
    }

    handleClickViewVideo = (item) => {
        const viewportWidth = document.documentElement.clientWidth;
        //const viewportHeight = document.documentElement.clientHeight;

        const newWidth =  viewportWidth / 2;
        const newHeigth = newWidth * 9 / 16;
        
        return this.props.showVideoPopup(
        <><ReactPlayer 
            //slot="media" 
            src={item.videoUrl} 
            controls={true} 
            autoPlay={false}
            preload={false}
            config={{ youtube: { playerVars: { cc_load_policy: 0 } }}}
            style={{width: newWidth+`px`, height: newHeigth+`px`, maxWidth: "1328px", margin: "auto", aspectRatio: '16/9'}}
            />
            <div className={classNames('videopopup_title', 'js-videopopup-title')}>
                {/* <a href={item.link} className={classNames('link-external', 'link-external__light', 'js-videopopup-link')} target="_blank" rel="noreferrer">
                    <span className={classNames('js-videopopup-link-text')}>{item.title}</span>&nbsp;<span className="link-external_ico"></span>
                </a> */}
                <Link
                    key={ item.link }
                    to={ getMediaUrl(item.link) }
                    state={{ lastUrl: document.location.href }}
                    className={ classNames('link-external', 'link-external__light', 'js-videopopup-link') }
                    target="_blank" 
                    preventScrollReset={true}
                >
                    <span className={classNames('js-videopopup-link-text')}>{item.title}</span>&nbsp;<span className="link-external_ico"></span>
                </Link>
            </div>
        </>)
    }

    renderSwiperElement = (item, index) => {
        //let index_url = item.video_url.indexOf('?v=');
        //let index_video = item.video_url.slice(index_url+3);

        const dataVideoUrl = 'https://www.youtube.com/embed/'+item.videoId+'/?autoplay=1&hl=ru&rel=0' // {item.video_url}
        const img_src = 'https://i.ytimg.com/vi/'+item.videoId+'/maxresdefault.jpg' //'https://img.youtube.com/vi/'+item.videoId+'/maxresdefault.jpg'

        const slideStyle = classNames('new-media__item', 'js-video-widget-hover-'+item.video_id, 'js-video-widget-popup-'+item.video_id)

        return (
            <SwiperSlide key={index}>
                <div onClick={() => this.handleClickViewVideo(item)} 
                    className={slideStyle} data-index={index} data-hover-class="news_link__hover" 
                    data-video-url={dataVideoUrl} data-page-title={item.title} >
                    {/* <div className={styles['new-media__cover']} style={{backgroundImage:"url(https://img.youtube.com/vi/1KASYghd_8A/maxresdefault.jpg)"}}></div> style={{pointerEvents: "none"}} */}
                    <img src={img_src} alt={`Video `+item.videoId}/>
                    <span className='small-news_play'></span>
                </div>
            </SwiperSlide>
        )
    }

    renderSwiper() {
        return this.props.videos.length !== 0 ? (
            <Swiper
                slidesPerView={4}
                //effect={'coverflow'} // EffectCoverflow
                /*coverflowEffect={{ // EffectCoverflow
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true,
                }}*/
                //grabCursor={false} // EffectCoverflow
                centeredSlides={false}
                loop={true}
                spaceBetween={20}
                initialSlide={0}
                loopAdditionalSlides={2}
                breakpoints={{
                    1408: {
                        slidesPerView: 4
                    }
                }}
                modules={[Navigation,]} // EffectCoverflow
                navigation={true}
                onSlideChange={() => {}} // console.log('slide change')
                onSwiper={(swiper) => {}} // console.log(swiper)
            >
                {this.props.videos.map((video, index) => this.renderSwiperElement(video, index))}
                <span className="swiper-gradient_left"></span>
                <span className="swiper-gradient_right"></span>
            </Swiper>
        ) : (
            <Error>Медиа отсутствуют</Error>
        )
    }

    render() {
        return (
            <div className='media-new' id="main_media_swiper" data-aos="fade-up">
                <div className='mp-container__media'>
                    {this.renderSwiperHeader()}
                </div>
                <div className='media-slider-overflow'>
                    <div className='media-slider-container'>
                        {this.renderSwiper()}
                    </div>
                </div>
            </div>
        )
    }
}

/*
var swiper = new Swiper(".swiper-slider", {
    modules: [Navigation],
    slidesPerView: 3,
    centeredSlides: false,
    loop: true,
    spaceBetween: 20,
    initialSlide: 1,
    loopAdditionalSlides: 2,
    breakpoints: {
        1408: {
            slidesPerView: 4,
        }
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
})
*/